module.exports = __webpack_public_path__ + "img/contract_logo.7afdd7c6.png";